module.exports = function getResource(label, vars = []) {
    let resources = {
        onlyFewLeftCopy: 'Only a few left'
    };

    return resources[label];
};
